export const GEOGRAPHY_CHECK_GLOMMEN_MJOSEN_SKOG_SA = 961700000
export const GEOGRAPHY_CHECK_GLOMMEN_SKOG_AS = 961700001
export const GEOGRAPHY_CHECK_OUTSIDE_OTHER = 961700002